export default "__VITE_ASSET__Q4X4imQn__"